export enum SicrediLogoTheme {
  Verde = 'verde',
  Branco = 'branco'
}
